import { render } from "./HeroiconsSolidClipboard.vue?vue&type=template&id=31f3018a"
const script = {}

import exportComponent from "C:\\wamp64\\www\\systems\\nova-erp-system\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidClipboard.vue"]])

export default __exports__